import React from 'react';
import { auth } from '../firebase';
import { GoogleAuthProvider, signInWithPopup } from "firebase/auth";
import HomeLogo from './HomeLogo';
import { useLocation, useNavigate } from 'react-router-dom';
import { database } from '../firebase';
import { ref, set, get } from 'firebase/database';

const Login = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const searchParams = new URLSearchParams(location.search);
    const gameID = searchParams.get('game');
    const solo = searchParams.get('solo');

    const googleSignIn = async () => {
        const provider = new GoogleAuthProvider();
        try {
            const result = await signInWithPopup(auth, provider);
            const user = result.user;
    
            const userRef = ref(database, `users/${user.uid}`);
            const snapshot = await get(userRef);
            if (!snapshot.exists()) {
                set(userRef, { name: user.displayName, email: user.email });
            }
            if(gameID) {
                let gameURL = `/join/${gameID}`;
                if(solo) {
                    gameURL += '&solo=1';
                }
                navigate(gameURL);
            } else {
                navigate('/');
            }
            
        } catch (error) {
            console.error(error);
        }
    };

    return (
        <div className="sg-page">
            <HomeLogo />
            <div className="sg-center-col" style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', paddingBottom: '12vh' }}>
                <div className="sg-card sg-anim-fadeup" style={{ textAlign: 'center' }}>
                    <span className="sg-kicker">Welcome back</span>
                    <h2 style={{ fontSize: '2rem', margin: '8px 0 6px' }}>
                        Let's play 🎲
                    </h2>
                    <p className="sg-muted" style={{ margin: '0 0 22px' }}>
                        Sign in to save your scores and join games.
                    </p>

                    <button
                        type="button"
                        className="sg-btn sg-btn--ghost sg-btn--block sg-btn--lg"
                        onClick={googleSignIn}
                    >
                        <img src="/google-logo.png" alt="" style={{ width: 22, height: 22 }} />
                        Sign in with Google
                    </button>

                    <p className="sg-muted" style={{ margin: '18px 0 0' }}>
                        or <span className="sg-link" onClick={() => navigate(`/guest?game=${gameID}`)}>jump in as a guest</span>
                    </p>
                </div>
            </div>
        </div>
    );
};

export default Login;
